import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        can('read', 'Permissao');
        if (user.temPermissao(['acesso_total'])) {
            can('manage', 'Permissao');
        }
        user.roles?.forEach((perm: string) => {
            if (perm.includes('admin'))
                can('editar', 'Permissao');
        });
    }
    return build()
}